import React from 'react';
import { Map } from 'react-feather';
import './Header.css';

interface HeaderProps {
  onZoneClick: () => void;
  currentZone: string;
  hideZoneInfo?: boolean;
}

export const Header: React.FC<HeaderProps> = ({
  currentZone,
  onZoneClick,
  hideZoneInfo = false,
}) => {
  return (
    <header className="header">
      <div className="header-content">
        <h1 className="app-title">TowApp</h1>
        
        {!hideZoneInfo && (
          <div className="header-actions">
            <div className="zone-info" onClick={onZoneClick}>
              <Map size={14} />
              {currentZone}
            </div>
          </div>
        )}
      </div>
    </header>
  );
}; 